import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import InformationModal from '@/components/global/popup/InformationModal.vue';
import { useGlobalNotification } from '@/shared/composables/useGlobalNotification';
import i18n from '@/i18n';

/* === Login alert === */

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginAlertModal',
  setup(__props) {

const { isLoginAlertVisibleInStore, closeLoginAlert } = useGlobalNotification();
const title = computed(() => i18n.t("We've updated ROLTEKApp") as string);
const message = computed(() =>
    [
        i18n.t(
            "We've rebuilt the system behind the scenes. Everything should work as before, but an occasional error is still possible.",
        ),
        i18n.t("If something doesn't work, please let us know and we'll fix it as soon as possible."),
    ].join('\n\n'),
);

return { __sfc: true,isLoginAlertVisibleInStore, closeLoginAlert, title, message, InformationModal }
}

})